import React from 'react';
import { css } from '@emotion/core';
import {
	ArrowIconLight,
	Css,
	Responsive,
	StyledIconLink,
	StyledLinkText,
} from '@/ui';
import styled from '@emotion/styled';
import { getJobDetailsUrl } from '../../../domain/use-cases/getJobDetailsUrl';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { StyledLink } from '../../../../flights/overview/ui/list/columns/DetailsLink';

interface IDetailsLinkProps {
	slug: string;
	jobTitle: string;
}

const styles = css`
	display: flex;
	text-align: right;
	${StyledIconLink} {
		white-space: nowrap;

		${StyledLinkText} {
			text-overflow: initial;
			overflow: initial;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 65px;
		margin-top: ${Css.pxToRem(10)};
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
	justify-content: flex-end;
`;

export function Header() {
	return <StyledHeader />;
}

export function Cell({ slug, jobTitle }: IDetailsLinkProps) {
	const href = getJobDetailsUrl(slug);
	return (
		<StyledCell>
			<StyledLink
				href={href}
				aria-label={`Details for ${jobTitle}`}
				title={`Details for ${jobTitle}`}
			>
				Details
				<ArrowIconLight />
			</StyledLink>
		</StyledCell>
	);
}
